import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export type BodyLineStyle = 'normal' | 'highlighted' | 'bold-bullet';

export interface BodyLine {
    translationKey: string;
    interpolateParameters?: { [key: string]: string | number };
    style?: BodyLineStyle;
}

export type ConfirmationDialogData = {
    headerTranslationKey: string;
    headerInterpolateParameters?: { [key: string]: string | number };
    confirmationQuestion: {
        translationKey: string;
        interpolateParameters: { [key: string]: string | number };
    };
    bodyLines?: BodyLine[];
    confirmButtonTranslationKey: string | null;
    rejectButtonTranslationKey: string | null;
    transferData: any;
    iconPath?: string;
};

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    standalone: false,
})
export class ConfirmationDialogComponent {
    readonly defaultIconPath = 'assets/svg/reusable-svg/warning.svg';

    constructor(
        public dialogRef: MatDialogRef<
            ConfirmationDialogComponent,
            ConfirmationDialogData
        >,
        @Inject(MAT_DIALOG_DATA)
        public injectedData: ConfirmationDialogData
    ) {
        //adds css class for styling in global styles
        this.dialogRef.addPanelClass('tryb-confirmation-dialog');
    }

    get iconPath(): string {
        return this.injectedData.iconPath ?? this.defaultIconPath;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onSubmit() {
        this.dialogRef.close(this.injectedData.transferData);
    }
}
